import { addZeroToStart } from '@interlayer/js/app/utils/methods.util';

import { TIME_PERIODS } from './constants';
import { TTickTimerProps, TTickTimerValue } from './types';

const DEFAULT_ADDING_ZEROS = {
    days: false,
    hours: true,
    min: true,
    sec: true
};

export const DEFAULT_TIMER_VALUE = {
    days: '0',
    hours: '00',
    min: '00',
    sec: '00'
};

export const getLeftTime = (diff: number) => {
    const sec = Math.round(diff / 1000);
    const min = Math.floor(sec / 60);
    const hours = Math.floor(min / 60);
    const days = Math.floor(hours / 24);

    return {
        days,
        hours,
        min,
        sec
    };
};

export const tickTimer = (props?: TTickTimerProps): TTickTimerValue => {
    const { countTo, addingZeros = DEFAULT_ADDING_ZEROS } = props || {};

    if (!countTo) {
        return DEFAULT_TIMER_VALUE;
    }

    const diff = Number(new Date(countTo)) - Date.now();

    if (diff + 500 < 0) {
        return {
            ...DEFAULT_TIMER_VALUE,
            restTime: 0
        };
    }

    const { days, hours, min, sec } = getLeftTime(diff);

    const withZero = (restTime: number, name: TIME_PERIODS) => {
        const restTimeString = `${restTime}`;

        return addingZeros[name]
            ? addZeroToStart(restTimeString)
            : restTimeString;
    };

    return {
        [TIME_PERIODS.days]: withZero(days, TIME_PERIODS.days),
        [TIME_PERIODS.hours]: withZero(hours % 24, TIME_PERIODS.hours),
        [TIME_PERIODS.min]: withZero(min - hours * 60, TIME_PERIODS.min),
        [TIME_PERIODS.sec]: withZero(sec - min * 60, TIME_PERIODS.sec),
        restTime: sec
    };
};
